"use strict";
exports.__esModule = true;
exports.Cookie = void 0;
var setParamInCookie = function (key, value) {
    document.cookie = key + "=" + value;
};
var getParamsInCookie = function () {
    return JSON.stringify(document.cookie.split('=')[1]);
};
exports.Cookie = { setParamInCookie: setParamInCookie, getParamsInCookie: getParamsInCookie };
//# sourceMappingURL=cookie.js.map